// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconChili = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M17.483 6.108A4.5 4.5 0 0121 10.5V13a9 9 0 11-18 0h.02a6 6 0 01-.02-.48h2A3.49 3.49 0 008.5 16a3.49 3.49 0 003.5-3.48V10h.027a4.5 4.5 0 013.444-3.882A2.5 2.5 0 0013 4V2a4.5 4.5 0 014.483 4.108M16.5 8a2.5 2.5 0 00-2.5 2.5v2.02C14 15.55 11.533 18 8.5 18c-.57 0-1.122-.087-1.64-.248A7 7 0 0019 13v-2.5A2.5 2.5 0 0016.5 8"
    />
  );
export default SvgIconChili;
